import { ButtonStyled } from "@Theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "@Theme/common/ContentDetailOrderActions.styled"
import { IconCheck } from "@Theme/common/Icon.styled"
import { IDeliveryAction } from "@Interfaces/IShippingGroupAction"

const DeliveryAction = ({ loadingDelivery, onClickDeliveryOrder }: IDeliveryAction) => {
  return (
    <ContentDetailOrderActionsStyled>
      <ButtonStyled
        variant="primary"
        loadingButton={loadingDelivery}
        disabled={loadingDelivery}
        onClick={onClickDeliveryOrder}
      >
        <IconCheck />
        <span>Despachar orden</span>
      </ButtonStyled>
    </ContentDetailOrderActionsStyled>
  )
}

export default DeliveryAction
